import React from 'react';
import {Form} from 'formik';
import {Formik} from 'formik';
import Button from '../../../../../../components/form/button/button';
import TextField from '../../../../../../components/form/textfield/textfield';
import CustomModal from '../../../../../../components/custom-modal/custom-modal';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  event_name: Yup.string()
    .required('Event name is required')
    .min(1, 'Event name cannot be empty')
    .max(255, 'Event name is too long'),
  description: Yup.string()
    .max(1000, 'Description is too long'),
});

export default function AddFailureModeModal({
  show,
  setShow,
  onSubmit,
  isLoading = false,
}) {
  const initialValues = {
    event_name: '',
    description: '',
  };

  const handleSubmit = (values, {resetForm}) => {
    onSubmit(values);
    resetForm();
  };

  return (
    <CustomModal
    show={show}
    setShow={setShow}
    title="Add Failure Mode"
    style={{maxWidth:"500px"}}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
    
        enableReinitialize>
        {({formik, values, setFieldValue, errors, touched, isValid,resetForm}) => (
          <Form style={{display:"flex",flexDirection:"column", gap:"16px"}}>
            <div style={{textAlign: 'left',marginTop:"8px"}}>
              <TextField
                label="Failure Mode Name"
                name="event_name"
                placeholder="Enter failure mode name"
                required
              />
            </div>
            <div style={{textAlign: 'left'}}>
              <TextField
                label="Description (Optional)"
                name="description"
                placeholder="Enter description"
                isMultiline
                rows={3}
              />
            </div>
            <div className="action-buttons mt-3" style={{display: 'flex', gap: '1rem', justifyContent: 'flex-end'}}>
              <Button
                type="button"
                 variant={"secondary-button"}
                clickHandler={() => {
                  setShow(false);
                  resetForm()
                }}
                disabled={isLoading}>
                Cancel
              </Button>
              <Button
                type="submit"
                variant="submit-button"
                disabled={!isValid || isLoading}>
                {isLoading ? 'Creating...' : 'Create'}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </CustomModal>
  );
}

